export const GENERAL_SAML_DATA_ERROR = 'sso.saml-domain-is-use'
export const INVALID_ISSUER_URL = 'sso.invalid-issuer-url'
export const INVALID_NAMEID_FORMAT = 'sso.invalid-nameid-format'
export const CERTIFICATE_MISSING = 'sso.certificate-missing'
export const CERTIFICATE_INVALID = 'sso.certificate-invalid'
export const DOMAIN_NOT_BELONG_TO_ORG = 'sso.domain-not-belong-to-org'
export const UNABLE_TO_UPDATE_MULTIPLE_DOMAINS =
  'sso.unable-to-update-multiple-domains'
export const EMAIL_DOMAIN_NOT_VEIRIFIED = 'sso.email-not-verified'
